import { render, staticRenderFns } from "./ProjectActionsButtons.vue?vue&type=template&id=3ad64e86&scoped=true"
import script from "./ProjectActionsButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectActionsButtons.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProjectActionsButtons.vue?vue&type=style&index=0&id=3ad64e86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad64e86",
  null
  
)

export default component.exports